import { gql } from '@apollo/client';
import { SIMPLR_ACCOUNT_FIELDS_FRAGMENT } from './simplrAccountFieldsFragment.gql';
import { LAST_MESSAGE_FIELDS_FRAGMENT } from './lastMessageFieldsFragment.gql';
import { CUSTOMER_FIELDS_FRAGMENT } from './customerFieldsFragment.gql';
import { SIMPLR_EXPERT_FIELDS_FRAGMENT } from './simplrExpertFieldsFragment.gql';

export const CONVERSATION_FIELDS_FRAGMENT = gql`
  ${SIMPLR_ACCOUNT_FIELDS_FRAGMENT}
  ${SIMPLR_EXPERT_FIELDS_FRAGMENT}
  ${LAST_MESSAGE_FIELDS_FRAGMENT}
  ${CUSTOMER_FIELDS_FRAGMENT}
  fragment ConversationFields on Conversation {
    id
    objectId: id
    createdAt
    updatedAt
    lastMessageObjectId
    subject
    customerChannel
    simplrChannel
    lastMessageBody
    conversationType
    status
    lastMessageDirection
    zendeskTicketId
    zendeskDomain
    simplrTicketNumber
    smbName
    conversationSid
    deskTicketId
    deskDomain
    Comments
    paymentStatus
    platformAssigneeName
    autoResponse
    communicationType
    platformTicketId
    platformDomain
    orderingSystem
    sessionToken
    comments
    platformStatus
    lastAutoRoutingAlgorithm
    platformAssigneeType
    include
    invalidDamien
    brand
    chatStatus
    department
    externalOperatorDecision
    responseCompleteness
    firstMessageObjectId
    associatedOrderNumber
    category
    reviewStatus
    platformAuthorId
    chatResponseState
    language
    isOpen
    onHold
    hasSentSurvey
    isTestTicket
    useMasterKey
    escalatedForReview
    unreadCount
    shopifyOrderNumber
    platformAssigneeId
    rating
    numValidationsRequired
    conversationUpdatedAt
    firstMessageArrivedAt
    closedAt
    lastInboundMessageAt
    originalCreatedAt
    escalatedAt
    conversationOpenedAt
    firstExpertResponseSentAt
    firstReadyForNominationAt
    ticketReviewedAt
    lastStatusChangedAt
    lastSyncedAt
    chatDelayedAt
    simplrAccountId
    closedById
    closedByExpertId
    simplrExpertId
    reviewExpertId
    reviewExpertPtr {
      id
      objectId: id
    }
    simplrAccountPtr {
      ...SimplrAccountFields
    }
    simplrExpertPtr {
      ...SimplrExpertFields
    }
    closedByUserId
    lastMessageId
    lastMessagePtr {
      ...LastMessageFields
    }
    customerId
    customerPtr {
      ...CustomerFields
    }
    channelId
    decisionFlowStatusId
    transcriptId
    roomId
    transcriptUrl
    platformTicketType
    combinedTags
    qualityRating
    platformTags
    moreTicketInfo
    extraTicketInfo
    tagHistory
    pendingPartnerReachOut
  }
`;
